module.exports = __webpack_public_path__ + "arrow_right.d9ccc77c8240ad0dc272.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/img/svg/arrow_right.svg
// module id = ../../../../../src/img/svg/arrow_right.svg
// module chunks = 1